export enum Experiment {
  EnablePPCreditAndVenmoTest = 'specs.payments.EnablePPCreditAndVenmoTest',
  RestartPayFlowForSpbIfErrorHappens = 'spec.payments-checkout.RestartPayFlowForSpbIfErrorHappens',
  EnableVenmoEligibility = 'spec.payments-checkout.EnableVenmoEligibility',
}
